export default __webpack_public_path__ + "static/media/pdf.4ab08a6c.svg";